import React from 'react';
import Application1 from '../../Assets/images/Application-1.png'
import Application2 from '../../Assets/images/Application-2.png'
import Application3 from '../../Assets/images/Application-3.png'
import Application4 from '../../Assets/images/Application-4.png'
const HowWeWorks = () => {
  return (
    <div className="w-full  bg-gray-100 md:px-28 px-6 md:py-10 py-6">
      <div className="text-center ">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 md:mb-2 mb-0 heading">
          How we works ?
        </h1>
        <p className="text-gray-600 text-sm md:mb-6 mb-8 paragraph">
          This is a process, how you can get UPAS/LC for your self.
        </p>
      </div>

      <div className="container mx-auto">
        <div className="mx-auto md:px-0 md:py-10 flex md:flex-col lg:flex-row items-center justify-between md:gap-32 gap-6 md:mb-0 mb-4">
          {/* Right Section: Image */}
          <div className="lg:w-1/2 md:pl-32">
            <img
              src={Application1}
              alt="Application1"
              className="md:w-72 w-96 h-28 md:h-auto"
            />
          </div>

          {/* Left Section: Text and Button */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-3xl md:text-6xl font-bold text-headerBtn md:mb-4 mb-0 mt-4">
              01
            </h1>
            <h1 className="text-1xl md:text-2xl font-bold text-gray-800 md:mb-4 mb-0">
              Application
            </h1>
            <p className="text-gray-600 md:text-sm text-xs mb-6">
              The borrower fills out the UPAS/LC application form, providing
              essential details. Once complete, the application is submitted for
              processing.
            </p>
          </div>
        </div>

        <div className=" mx-auto md:px-10 md:py-10 flex md:flex-col gap-5 lg:flex-row items-center justify-between md:mb-0 mb-4">
          {/* Left Section: Text */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-3xl md:text-6xl font-bold text-headerBtn md:mb-4 ">
              02
            </h1>
            <h1 className="text-1xl md:text-2xl font-bold text-gray-800 md:mb-4">
              Application Review
            </h1>
            <p className="text-gray-600 md:text-sm text-xs mb-6">
              The bank requests necessary documents like ID proof, income
              statements, and collateral details. These are vital for assessing
              the application.
            </p>
          </div>

          {/* Right Section: Image */}
          <div className="lg:w-1/2">
            <img
              src={Application2}
              alt="Application1"
              className="md:w-80 w-96 h-32 md:h-auto"
            />
          </div>
        </div>

        <div className=" mx-auto gap-6 md:px-10 md:py-10 flex md:flex-col lg:flex-row items-center justify-between md:mb-0 mb-4">
          {/* Right Section: text */}
          <div className="lg:w-1/2 md:pl-32">
            <img
              src={Application3}
              alt="Application1"
              className="md:w-80 w-96 h-32 md:h-auto"
            />
          </div>

          {/* Left Section: Image */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-3xl md:text-6xl font-bold text-headerBtn md:mb-4">
              03
            </h1>
            <h1 className="text-1xl md:text-2xl font-bold text-gray-800 md:mb-4">
              Authority Evaluation
            </h1>
            <p className="text-gray-600 text-xs md:text-sm mb-6">
              The bank verifies the submitted documents to ensure accuracy. This
              step is crucial for determining the borrower's creditworthiness.
            </p>
          </div>
        </div>

        <div className=" mx-auto gap-5 md:px-10 md:py-10 flex md:flex-col lg:flex-row items-center justify-between">
          {/* Left Section: Text */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-3xl md:text-6xl font-bold text-headerBtn md:mb-4">
              04
            </h1>
            <h1 className="text-1xl md:text-2xl font-bold text-gray-800 md:mb-4">
              UPAS/LC Approval
            </h1>
            <p className="text-gray-600 text-xs md:text-sm mb-6">
              After verification, the bank evaluates the application based on
              set criteria. If eligible, the UPAS/LC is approved and ready for
              disbursement.
            </p>
          </div>

          {/* Right Section: Image */}
          <div className="lg:w-1/2">
            <img
              src={Application4}
              alt="Application4"
              className="md:w-80 w-96 h-32 md:h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWeWorks;